import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';

import { SwitchStyled, FormControlLabelStyled } from './Switch.styled';

const SwitchField = ({
  form,
  label,
  inline,
  onChange,
  disabled,
  inputProps,
  labelClasses,
  labelPlacement,
  validateChecked,
  field: { name, value },
  ...restProps
}) => {
  const [checked, setChecked] = useState(value || false);

  const toggleChecked = () => {
    form.setFieldValue(name, !checked);
    if (onChange) {
      onChange(!checked);
    }
    if (!validateChecked) {
      setChecked((prev) => !prev);
    }
  };

  useEffect(() => {
    setChecked(value);
  }, [value, setChecked]);

  const getSwitch = () => {
    return (
      <FormControlLabelStyled
        value="start"
        label={label}
        control={
          <SwitchStyled
            name={name}
            value={value}
            checked={checked}
            disabled={disabled}
            color="primary"
            onChange={toggleChecked}
            inputProps={{
              'aria-label': name,
              ...inputProps,
            }}
            data-cy={restProps['data-cy']}
          />
        }
        labelPlacement={labelPlacement}
        classes={labelClasses}
      />
    );
  };

  return (
    <>
      {!inline ? (
        <FormControl component="fieldset">
          <FormGroup aria-label="position" row>
            {getSwitch()}
          </FormGroup>
        </FormControl>
      ) : (
        <>{getSwitch()}</>
      )}
    </>
  );
};

SwitchField.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onChange: PropTypes.func,
  }),
  onChange: PropTypes.func,
  inputProps: PropTypes.object,
  validateChecked: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  inline: PropTypes.bool,
  labelPlacement: PropTypes.oneOf(['top', 'start', 'bottom', 'end']),
};

SwitchField.defaultProps = {
  inline: false,
  inputProps: {},
  checked: false,
  disabled: false,
  validateChecked: false,
  labelPlacement: 'start',
};

export default SwitchField;
